module.exports = __webpack_public_path__ + "static/img/img_3.0b930417.jpg";